import { Quote } from "lucide-react";
import { Reveal } from "@/components/site/Motion";

const TESTIMONIALS = [
  {
    quote: "Au-delà de nos espérances, une rencontre merveilleuse, qui a donné lieu à un accompagnement pédagogue global — toute la famille, humains et animaux — bienveillant et tellement pertinent. Vous serez conquis, je vous l'assure.",
    author: "Séverine N.",
    place: "Muneville-le-Bingard",
  },
];

export default function Testimonials() {
  return (
    <section className="px-6 py-24 sm:px-10 md:py-32 lg:px-16" data-testid="home-testimonials">
      <div className="mx-auto max-w-7xl">
        <Reveal>
          <p className="overline-label">Témoignages</p>
          <h2 className="mt-4 max-w-2xl font-serif text-3xl font-medium leading-[1.15] tracking-tight text-ink sm:text-4xl md:text-5xl">
            Des familles qui ont retrouvé <span className="italic text-terracotta">leur équilibre.</span>
          </h2>
        </Reveal>
        <div className="mx-auto mt-16 max-w-2xl">
          {TESTIMONIALS.map((t, i) => (
            <Reveal key={t.author} delay={0.1 * i} y={40}>
              <figure
                className="flex h-full flex-col rounded-[2rem] border border-stone-border bg-white/70 p-10 transition-transform duration-300 hover:-translate-y-1.5"
                data-testid={`testimonial-card-${i + 1}`}
              >
                <span className="flex h-11 w-11 items-center justify-center rounded-full bg-terracotta/10 text-terracotta">
                  <Quote size={18} strokeWidth={1.8} />
                </span>
                <blockquote className="mt-6 flex-1 font-serif text-xl italic leading-relaxed text-ink/85">
                  « {t.quote} »
                </blockquote>
                <figcaption className="mt-8 text-xs font-bold uppercase tracking-[0.2em] text-ink/50">
                  {t.author} <span className="text-terracotta">· {t.place}</span>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
